import api from '../utils/api';

const mapType = (row) => ({
  id: row.id,
  name: row.name
});

function registerListParams(options = {}) {
  const params = {};
  if (options.archived) params.archived = 'true';
  return params;
}

export const listPlantAndMachineryTypes = async () => {
  const res = await api.get('/asset-management/plant-and-machinery');
  return (res.data?.data || []).map(mapType);
};

export const createPlantAndMachineryType = async (name) => {
  const res = await api.post('/asset-management/plant-and-machinery', { name });
  return mapType(res.data?.data || {});
};

export const getPlantAndMachineryConfig = async (typeId) => {
  const res = await api.get(`/asset-management/plant-and-machinery/${typeId}/config`);
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listPlantAndMachineryTypesForProject = async (projectId) => {
  const res = await api.get(`/asset-management/projects/${projectId}/plant-and-machinery/types`);
  return (res.data?.data || []).map(mapType);
};

export const getPlantAndMachineryConfigForProject = async (projectId, typeId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/plant-and-machinery/types/${typeId}/config`
  );
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listPlantAndMachineryRecords = async (projectId, options = {}) => {
  const res = await api.get(`/asset-management/projects/${projectId}/plant-and-machinery`, {
    params: registerListParams(options)
  });
  return res.data?.data || [];
};

export const getPlantAndMachineryRecord = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/plant-and-machinery/${recordId}`
  );
  return res.data?.data || {};
};

export const createPlantAndMachineryRecord = async (projectId, formData) => {
  const res = await api.post(
    `/asset-management/projects/${projectId}/plant-and-machinery`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const updatePlantAndMachineryRecord = async (projectId, recordId, formData) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/plant-and-machinery/${recordId}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const savePlantAndMachineryConfig = async (typeId, config) => {
  const res = await api.put(`/asset-management/plant-and-machinery/${typeId}/config`, {
    customFields: config.customFields,
    checklistType: config.checklistType,
    checklistVersion: config.checklistVersion,
    checklistItems: config.checklistItems
  });
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listEquipmentTypes = async () => {
  const res = await api.get('/asset-management/equipment');
  return (res.data?.data || []).map(mapType);
};

export const createEquipmentType = async (name) => {
  const res = await api.post('/asset-management/equipment', { name });
  return mapType(res.data?.data || {});
};

export const getEquipmentConfig = async (typeId) => {
  const res = await api.get(`/asset-management/equipment/${typeId}/config`);
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const saveEquipmentConfig = async (typeId, config) => {
  const res = await api.put(`/asset-management/equipment/${typeId}/config`, {
    customFields: config.customFields,
    checklistType: config.checklistType,
    checklistVersion: config.checklistVersion,
    checklistItems: config.checklistItems
  });
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listTemporaryWorksTypes = async () => {
  const res = await api.get('/asset-management/temporary-works');
  return (res.data?.data || []).map(mapType);
};

export const createTemporaryWorksType = async (name) => {
  const res = await api.post('/asset-management/temporary-works', { name });
  return mapType(res.data?.data || {});
};

export const getTemporaryWorksConfig = async (typeId) => {
  const res = await api.get(`/asset-management/temporary-works/${typeId}/config`);
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const saveTemporaryWorksConfig = async (typeId, config) => {
  const res = await api.put(`/asset-management/temporary-works/${typeId}/config`, {
    customFields: config.customFields,
    checklistType: config.checklistType,
    checklistVersion: config.checklistVersion,
    checklistItems: config.checklistItems
  });
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listAccessEquipmentTypes = async () => {
  const res = await api.get('/asset-management/access-equipment');
  return (res.data?.data || []).map(mapType);
};

export const createAccessEquipmentType = async (name) => {
  const res = await api.post('/asset-management/access-equipment', { name });
  return mapType(res.data?.data || {});
};

export const getAccessEquipmentConfig = async (typeId) => {
  const res = await api.get(`/asset-management/access-equipment/${typeId}/config`);
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const saveAccessEquipmentConfig = async (typeId, config) => {
  const res = await api.put(`/asset-management/access-equipment/${typeId}/config`, {
    customFields: config.customFields,
    checklistType: config.checklistType,
    checklistVersion: config.checklistVersion,
    checklistItems: config.checklistItems
  });
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listAccessEquipmentTypesForProject = async (projectId) => {
  const res = await api.get(`/asset-management/projects/${projectId}/access-equipment/types`);
  return (res.data?.data || []).map(mapType);
};

export const getAccessEquipmentConfigForProject = async (projectId, typeId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/access-equipment/types/${typeId}/config`
  );
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listAccessEquipmentRecords = async (projectId, options = {}) => {
  const res = await api.get(`/asset-management/projects/${projectId}/access-equipment`, {
    params: registerListParams(options)
  });
  return res.data?.data || [];
};

export const getAccessEquipmentRecord = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/access-equipment/${recordId}`
  );
  return res.data?.data || {};
};

export const createAccessEquipmentRecord = async (projectId, formData) => {
  const res = await api.post(
    `/asset-management/projects/${projectId}/access-equipment`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const updateAccessEquipmentRecord = async (projectId, recordId, formData) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/access-equipment/${recordId}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const listAccessEquipmentInspections = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/access-equipment/${recordId}/inspections`
  );
  return res.data?.data || [];
};

export const getAccessEquipmentWeekInspections = async (projectId, recordId, weekStart) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/access-equipment/${recordId}/inspections/week`,
    { params: { weekStart } }
  );
  return res.data?.data || {};
};

export const listAccessEquipmentFaults = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/access-equipment/${recordId}/faults`
  );
  return res.data?.data || [];
};

export const closeAccessEquipmentFault = async (
  projectId,
  recordId,
  faultId,
  closureNotes,
  attachments = []
) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/access-equipment/${recordId}/faults/${faultId}/close`,
    { closureNotes, attachments }
  );
  return res.data?.data || {};
};

export const uploadAccessEquipmentFaultAttachment = async (projectId, recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/projects/${projectId}/access-equipment/${recordId}/faults/upload-attachment`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const getAccessEquipmentScanContext = async (recordId) => {
  const res = await api.get(`/asset-management/scan/access-equipment/${recordId}`);
  return res.data?.data || {};
};

export const uploadAccessEquipmentScanAttachment = async (recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/scan/access-equipment/${recordId}/upload-attachment`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const submitAccessEquipmentInspection = async (
  recordId,
  responses,
  signatureData,
  faults = [],
  attachments = []
) => {
  const res = await api.post(`/asset-management/scan/access-equipment/${recordId}`, {
    responses,
    signatureData,
    faults,
    attachments
  });
  return res.data?.data || {};
};

export const listTemporaryWorksTypesForProject = async (projectId) => {
  const res = await api.get(`/asset-management/projects/${projectId}/temporary-works/types`);
  return (res.data?.data || []).map(mapType);
};

export const getTemporaryWorksConfigForProject = async (projectId, typeId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/temporary-works/types/${typeId}/config`
  );
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listTemporaryWorksRecords = async (projectId, options = {}) => {
  const res = await api.get(`/asset-management/projects/${projectId}/temporary-works`, {
    params: registerListParams(options)
  });
  return res.data?.data || [];
};

export const getTemporaryWorksRecord = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/temporary-works/${recordId}`
  );
  return res.data?.data || {};
};

export const createTemporaryWorksRecord = async (projectId, formData) => {
  const res = await api.post(
    `/asset-management/projects/${projectId}/temporary-works`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const updateTemporaryWorksRecord = async (projectId, recordId, formData) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/temporary-works/${recordId}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const listTemporaryWorksInspections = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/temporary-works/${recordId}/inspections`
  );
  return res.data?.data || [];
};

export const getTemporaryWorksWeekInspections = async (projectId, recordId, weekStart) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/temporary-works/${recordId}/inspections/week`,
    { params: { weekStart } }
  );
  return res.data?.data || {};
};

export const listTemporaryWorksFaults = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/temporary-works/${recordId}/faults`
  );
  return res.data?.data || [];
};

export const closeTemporaryWorksFault = async (
  projectId,
  recordId,
  faultId,
  closureNotes,
  attachments = []
) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/temporary-works/${recordId}/faults/${faultId}/close`,
    { closureNotes, attachments }
  );
  return res.data?.data || {};
};

export const uploadTemporaryWorksFaultAttachment = async (projectId, recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/projects/${projectId}/temporary-works/${recordId}/faults/upload-attachment`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return res.data;
};

export const listEquipmentTypesForProject = async (projectId) => {
  const res = await api.get(`/asset-management/projects/${projectId}/equipment/types`);
  return (res.data?.data || []).map(mapType);
};

export const getEquipmentConfigForProject = async (projectId, typeId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/equipment/types/${typeId}/config`
  );
  const data = res.data?.data || {};
  return {
    customFields: data.customFields || [],
    checklistType: data.checklistType || 'detailed',
    checklistVersion: data.checklistVersion ?? 1,
    checklistItems: data.checklistItems || []
  };
};

export const listEquipmentRecords = async (projectId, options = {}) => {
  const res = await api.get(`/asset-management/projects/${projectId}/equipment`, {
    params: registerListParams(options)
  });
  return res.data?.data || [];
};

export const getEquipmentRecord = async (projectId, recordId) => {
  const res = await api.get(`/asset-management/projects/${projectId}/equipment/${recordId}`);
  return res.data?.data || {};
};

export const createEquipmentRecord = async (projectId, formData) => {
  const res = await api.post(
    `/asset-management/projects/${projectId}/equipment`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const updateEquipmentRecord = async (projectId, recordId, formData) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/equipment/${recordId}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data?.data || {};
};

export const listEquipmentInspections = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/equipment/${recordId}/inspections`
  );
  return res.data?.data || [];
};

export const getEquipmentWeekInspections = async (projectId, recordId, weekStart) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/equipment/${recordId}/inspections/week`,
    { params: { weekStart } }
  );
  return res.data?.data || {};
};

export const listEquipmentFaults = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/equipment/${recordId}/faults`
  );
  return res.data?.data || [];
};

export const closeEquipmentFault = async (
  projectId,
  recordId,
  faultId,
  closureNotes,
  attachments = []
) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/equipment/${recordId}/faults/${faultId}/close`,
    { closureNotes, attachments }
  );
  return res.data?.data || {};
};

export const uploadEquipmentFaultAttachment = async (projectId, recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/projects/${projectId}/equipment/${recordId}/faults/upload-attachment`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return res.data;
};

export const getEquipmentScanContext = async (recordId) => {
  const res = await api.get(`/asset-management/scan/equipment/${recordId}`);
  return res.data?.data || {};
};

export const uploadEquipmentScanAttachment = async (recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/scan/equipment/${recordId}/upload-attachment`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return res.data;
};

export const submitEquipmentInspection = async (
  recordId,
  responses,
  signatureData,
  faults = [],
  attachments = []
) => {
  const res = await api.post(`/asset-management/scan/equipment/${recordId}`, {
    responses,
    signatureData,
    faults,
    attachments
  });
  return res.data?.data || {};
};

export const getTemporaryWorksScanContext = async (recordId) => {
  const res = await api.get(`/asset-management/scan/temporary-works/${recordId}`);
  return res.data?.data || {};
};

export const uploadTemporaryWorksScanAttachment = async (recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/scan/temporary-works/${recordId}/upload-attachment`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return res.data;
};

export const submitTemporaryWorksInspection = async (
  recordId,
  responses,
  signatureData,
  faults = [],
  attachments = []
) => {
  const res = await api.post(`/asset-management/scan/temporary-works/${recordId}`, {
    responses,
    signatureData,
    faults,
    attachments
  });
  return res.data?.data || {};
};

export const getPlantAndMachineryScanContext = async (recordId) => {
  const res = await api.get(`/asset-management/scan/plant-and-machinery/${recordId}`);
  return res.data?.data || {};
};

export const uploadPlantAndMachineryScanAttachment = async (recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/scan/plant-and-machinery/${recordId}/upload-attachment`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return res.data;
};

export const submitPlantAndMachineryInspection = async (
  recordId,
  responses,
  signatureData,
  faults = [],
  attachments = []
) => {
  const res = await api.post(`/asset-management/scan/plant-and-machinery/${recordId}`, {
    responses,
    signatureData,
    faults,
    attachments
  });
  return res.data?.data || {};
};

export const listPlantAndMachineryFaults = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/plant-and-machinery/${recordId}/faults`
  );
  return res.data?.data || [];
};

export const closePlantAndMachineryFault = async (
  projectId,
  recordId,
  faultId,
  closureNotes,
  attachments = []
) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/plant-and-machinery/${recordId}/faults/${faultId}/close`,
    { closureNotes, attachments }
  );
  return res.data?.data || {};
};

export const uploadPlantAndMachineryFaultAttachment = async (projectId, recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/projects/${projectId}/plant-and-machinery/${recordId}/faults/upload-attachment`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return res.data;
};

export const getPlantAndMachineryWeekInspections = async (projectId, recordId, weekStart) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/plant-and-machinery/${recordId}/inspections/week`,
    { params: { weekStart } }
  );
  return res.data?.data || {};
};

export const listPlantAndMachineryInspections = async (projectId, recordId) => {
  const res = await api.get(
    `/asset-management/projects/${projectId}/plant-and-machinery/${recordId}/inspections`
  );
  return res.data?.data || [];
};

export const listReturnableAssets = async (projectId) => {
  const res = await api.get(`/asset-management/projects/${projectId}/register/returnable`);
  return res.data?.data || [];
};

export const uploadAssetCollectionAttachment = async (projectId, variant, recordId, file) => {
  const formData = new FormData();
  formData.append('attachment', file);
  const res = await api.post(
    `/asset-management/projects/${projectId}/register/${variant}/${recordId}/collection/upload-attachment`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return res.data;
};

export const confirmAssetReturnCollection = async (projectId, variant, recordId, collectedAt, attachments = []) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/register/${variant}/${recordId}/confirm-return-collection`,
    { collectedAt, attachments }
  );
  return res.data?.data || {};
};

export const archiveAssetRegisterRecord = async (projectId, variant, recordId) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/register/${variant}/${recordId}/archive`
  );
  return res.data?.data || {};
};

export const unarchiveAssetRegisterRecord = async (projectId, variant, recordId) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/register/${variant}/${recordId}/unarchive`
  );
  return res.data?.data || {};
};

export const returnAssetToSite = async (projectId, variant, recordId) => {
  const res = await api.patch(
    `/asset-management/projects/${projectId}/register/${variant}/${recordId}/return-to-site`
  );
  return res.data?.data || {};
};

export const getAssetManagementProjectDashboard = async (projectId, params = {}) => {
  const res = await api.get(`/asset-management/projects/${projectId}/dashboard`, { params });
  return res.data?.data || null;
};

/** Full-access register Excel export (plant-and-machinery | equipment | access-equipment | temporary-works). */
export const downloadAssetRegisterReport = async (projectId, variant) => {
  return api.get(`/asset-management/projects/${projectId}/${variant}/download-report`, {
    responseType: 'blob'
  });
};
